import Header from "../components/Header";
import FeedbackChart from "../components/FeedbackChart";
import { useRecoilValue } from "recoil";
import { impersonateData } from "../recoil/atom/impersonate";
import { useParams } from "react-router-dom";
import DigitalLeadsDashboard from "./DigitalLeadsDashboard";

function Dashboard() {
  const impersonateValues = useRecoilValue(impersonateData);
  const params = useParams();

  return (
    <div className="dark">
      <Header />
      {impersonateValues?.impersonate && (
        <div className="dark:bg-gray-900 text-white p-4">
          Currently Impersonating {impersonateValues.businessName}
        </div>
      )}
      <div>
        {params?.feedbackType?.toLowerCase().includes("digital") ? (
          <DigitalLeadsDashboard />
        ) : (
          <FeedbackChart />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
